// extracted by mini-css-extract-plugin
module.exports = {"heading":"AccordionItemHeading_heading__stvOT","icon":"AccordionItemHeading_icon__4Itpe"};